import script from "./profile_complete.vue?vue&type=script&setup=true&lang=ts"
export * from "./profile_complete.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__